<template>
	<div>
		<el-card shadow="never">
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item label="订单编号：">
					<el-input v-model="dataForm.order_id" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item label="课程名称：">
					<el-input v-model="dataForm.course_name" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item label="购买用户：">
					<el-input v-model="dataForm.user_name" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getUserTableList()">搜索</el-button>
					<el-button @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
			    <el-button type="primary" @click="network().downloadUserTableExcel()">导出</el-button>
			  </el-form-item> -->
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 30px;">
			<el-form :inline='true'>
				<el-form-item>
					<el-button type="primary" @click="exportData">批量导出
					</el-button>
				</el-form-item>
			</el-form>
			<el-table row-key="id" :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" @selection-change="handleChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="order_id" label="订单编号" align="center">
				</el-table-column>
				<el-table-column prop="course_name" label="课程名称" fit align="center">
				</el-table-column>
				<el-table-column prop="chapter_num" label="购买章节数" fit align="center">
				</el-table-column>
				<el-table-column prop="user_name" label="购买用户" fit align="center">
				</el-table-column>
				<!-- <el-table-column prop="phone" label="订单原价" fit align="center">
				</el-table-column>
				<el-table-column prop="phone" label="实付价格" fit align="center">
				</el-table-column> -->
				<el-table-column prop="score" label="订单原价" fit align="center">
				</el-table-column>
				<el-table-column prop="score" label="实付价格" fit align="center">
				</el-table-column>
				<el-table-column prop="create_time" label="购买时间" fit align="center">
				</el-table-column>
				<el-table-column label="操作" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="editAdminClick(scope.row)">查看</span>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<common-dialog :titleType="'删除'" :title="dialogTitle" :dialogVisible="dialogVisible"
				@cancel="dialogCancelClick" @confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div v-if="dialogType ==='delete'">
						<span style="color: #ff0000;">删除后将同步删除子分类</span>
					</div>
				</div>
			</common-dialog>


			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

		</el-card>
	</div>
</template>

<script>
	import XLSX from 'xlsx'
	import CommonDialog from "@/components/CommonDialog";
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getCourseOrderList,
	} from "@/api/orders"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				selectedTabIndex: "1",
				dataForm: {
					user_name: "",
					course_name: '',
					order_id: ''
				},
				showDialog: false,
				showDialogType: "Authentication",
				showDialogTitle: '',
				cancelBtnText: "",
				userAuthInfo: {},
				level: [{
					value: '等级',
					label: '等级'
				}],
				userStatuList: [{
					value: '状态',
					label: '状态'
				}],
				allChioce: [],
				allSelectIdList: [],
				selectForm: {},
				editdialogVisible: false,
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				passwordShow: false,
				passwordForm: {}
			};
		},
		components: {
			CommonPagination,
			CommonDialog
		},
		mounted() {
			this.network().getUserTableList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			exportData() {
				const headers = ['订单编号', '课程名称', '购买用户', '购买章节数', '订单原价', '实付价格', '购买时间']
				const data = this.tableData.map(item => [item.order_id, item.course_name, item.user_name, item.chapter_num,
					item.score, item.score, item.create_time
				])
				const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
				const workbook = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
				XLSX.writeFile(workbook, '课程订单.xlsx')
			},
			downLoadTemp() {
				window.location.href =
					'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/innovation/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			},
			resetPasswordClick(row) {
				this.passwordShow = true;
				this.passwordForm = row;
			},
			async UserDisableClick(item, is_disable) {
				const {
					status
				} = await UserDisable({
					id: item.uuid,
					is_disable: is_disable
				});
				this.$message.success('操作成功')
				if (status === 200) {
					this.network().getUserTableList();
				}
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						id: this.form.uuid
					}
					const {
						status
					} = await deleteUser(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getUserTableList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "当前一级分类吗";
			},
			//删除弹框结束
			closeDialog(row) {
				this.passwordShow = false
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getUserTableList()
			},
			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
			},
			//修改
			editAdminClick(row) {
				this.$router.push({
					path: '/course-order-detail?uuid=' + row.uuid
				})
			},
			handleChange(row) {
				this.allSelectIdList = row.map(item => item.user_id);
			},
			tabChange(e) {
				this.dataForm.status = e
				this.network().getUserTableList();
			},
			/**文件上传选择完成时触发的事件函数**/
			onFileChange(e) {
				let file = e.target.file[0]
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.order_id = ''
						this.dataForm.course_name = ''
						this.dataForm.user_name = ''
						this.page_index = 1
						this.network().getUserTableList();
					},
					handleClick: () => {
						this.network().getUserTableList();
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getUserTableList();
					},
					/**
					 * 点击全选
					 * @param {Object} index
					 */
					onAllChioceChange: (row) => {
						//全选将List中的id提取出来
						this.allSelectIdList = row.map(item => item.user_id);
					},
					/**
					 * 已认证用户点击
					 */
					onShowDialogClick: (btn, data) => {
						this.showDialog = true;
						this.showDialogType = btn;
						this.userAuthInfo = data;
						this.showDialogTitle = '认证信息';
						this.cancelBtnText = "返回"
					},
					onCloseModalClick: () => {
						this.showDialog = false;
					},
					/**
					 * 查看用户详情
					 */
					handleOperationClick: (data) => {
						this.$router.push({
							path: "/user-detail?uuid=" + data.uuid
						})
					},
					/**
					 * 解禁/禁用
					 * @param {Object} uuid
					 */
					handleIsDisableclick: (uuid, is_blacklist) => {
						// var uuidList = uuid.split(",");
						this.network().newWorkIsDisableClick(uuid, is_blacklist);
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getUserTableList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getUserTableList();
					},
					onBatchApprovalClick: (isDisable) => {
						if (this.allSelectIdList.length > 0) {
							if (isDisable) { // true 解
								this.network().batchUnDisable()
							} else {
								this.network().batchDisable()
							}
						} else {
							this.$message.error('请点击全选选项');
						}
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							user_name: this.dataForm.user_name,
							course_name: this.dataForm.course_name,
							order_id: this.dataForm.order_id
						};
						const {
							status,
							data
						} = await getCourseOrderList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},

					batchDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
					batchUnDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchUnDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},


					disableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await disableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},

					ableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await ableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>